import React, { useRef, useEffect } from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  annotationPlugin
);

export default function InvestGraph({ onNext, amount, graphObject }) {
  console.log("graphObject2", graphObject);
  console.log("amount", amount);

  const performanceData = graphObject?.performanceData;

  const values = performanceData?.map((item) => item.value);
  const dates = performanceData?.map((item) => item.label);

  const today = new Date();
  const formattedToday = today.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const amountYearly = [0, ...values];
  const durationYearly = [formattedToday, ...dates];
  console.log("amountYearly", amountYearly);
  console.log("durationYearly", durationYearly);
  const chartRef = useRef(null);
  const hasValidData =
    Array.isArray(amountYearly) &&
    Array.isArray(durationYearly) &&
    amountYearly.length > 0 &&
    durationYearly.length > 0 &&
    amountYearly.length === durationYearly.length &&
    amountYearly.every((v) => v != null) &&
    durationYearly.every((v) => v != null);

  useEffect(() => {
    const chart = chartRef.current;
    if (chart && hasValidData) {
      const indexToActivate = amountYearly.length > 1 ? 1 : 0;
      chart.tooltip.setActiveElements(
        [
          {
            datasetIndex: 0,
            index: indexToActivate,
          },
        ],
        { x: 0, y: 0 }
      );
      chart.update();
    }
  }, []);

  let cumulative = Number(amount);
  const cumulativeData = amountYearly.map((yearlyAmount) => {
    cumulative += Number(yearlyAmount);
    return cumulative;
  });

  const labels = durationYearly;
  const dataPoints = amountYearly;

  const lastLabel = labels[labels.length - 1];
  const lastValue = dataPoints[dataPoints.length - 1];

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Investment Value",
        data: dataPoints,
        fill: true,
        backgroundColor: "rgba(105, 65, 198, 0.2)",
        borderColor: "hsl(var(--brand-secondary))",
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        display: false,
        grid: {
          drawTicks: false,
          drawBorder: false,
          display: false,
        },
      },
      x: {
        display: true,
        grid: {
          drawTicks: false,
          drawBorder: false,
          display: false,
        },
        ticks: {
          color: "hsl(var(--text-muted))",
          font: {
            size: 12,
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      annotation: {
        annotations: {
          markerLine: {
            type: "line",
            scaleID: "x",
            value: lastLabel,
            borderColor: "purple",
            borderWidth: 2,
            drawTime: "afterDraw",
            label: {
              enabled: true,
              content: [lastLabel, `R${lastValue}`], // dynamic label + value
              position: "top",
              backgroundColor: "hsl(var(--background))",
              color: "hsl(var(--brand-secondary))",
              font: {
                size: 12,
                weight: "bold",
              },
            },
          },
        },
      },
    },
  };

  return (
    <div className="relative h-72 w-full">
      {!hasValidData && (
        <div className="absolute inset-0 z-10 bg-white/70 backdrop-blur-md flex items-center justify-center text-center px-4 text-gray-700 font-medium rounded-lg pointer-events-none">
          No data available to display the investment chart.
        </div>
      )}

      <div className={`${!hasValidData ? "opacity-30" : ""}`}>
        <Line ref={chartRef} data={data} options={options} />
      </div>

      <div className="mt-5 flex justify-center z-20 relative">
        <button
          type="button"
          onClick={() => {
            onNext?.();
          }}
          className="px-32 py-3 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full text-sm font-medium"
        >
          {hasValidData ? "Nice one! Let's go" : "Okay Let's Continue"}
        </button>
      </div>
    </div>
  );
}
